import { render, staticRenderFns } from "./CourseCalendar.vue?vue&type=template&id=e8e83e9a&scoped=true"
import script from "./CourseCalendar.vue?vue&type=script&lang=js"
export * from "./CourseCalendar.vue?vue&type=script&lang=js"
import style0 from "./CourseCalendar.vue?vue&type=style&index=0&id=e8e83e9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e83e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8e83e9a')) {
      api.createRecord('e8e83e9a', component.options)
    } else {
      api.reload('e8e83e9a', component.options)
    }
    module.hot.accept("./CourseCalendar.vue?vue&type=template&id=e8e83e9a&scoped=true", function () {
      api.rerender('e8e83e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseCalendar.vue"
export default component.exports